import {
  OTHER_INCOME_CHANGE_REASON_OPTIONS,
  type OtherIncomeChangeReason,
} from './otherIncomeEarnerTypes';

export function isOtherIncomeChangeReasonCode(value: string): value is OtherIncomeChangeReason {
  return (OTHER_INCOME_CHANGE_REASON_OPTIONS as readonly string[]).includes(value);
}

export function otherIncomeChangeReasonLabelKey(code: OtherIncomeChangeReason): string {
  return `submitDocuments.dependentDeduction.otherIncomeEarner.changeReason.${code}`;
}

function normalizeOtherIncomeChangeReasonCode(stored: string): string {
  const v = stored.trim().toLowerCase();
  if (v === 'married') return 'marriage';
  return stored.trim();
}

export function formatOtherIncomeChangeReasonDisplay(
  t: (k: string) => string,
  stored: string,
  otherText?: string
): string {
  const normalized = normalizeOtherIncomeChangeReasonCode(stored);
  if (!normalized) return '';
  if (isOtherIncomeChangeReasonCode(normalized)) {
    if (normalized === 'other') {
      const text = otherText?.trim();
      return text || t(otherIncomeChangeReasonLabelKey('other'));
    }
    return t(otherIncomeChangeReasonLabelKey(normalized));
  }
  return stored.trim();
}
